import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styles from './SidebarMenu.module.less';

const SidebarMenuItem = ({ item }) => {
  if (item.text === 'Help Center') {
    return (
      <h4 className={styles.vpDrawerLink}>
        <a href={item.url}>{item.text}</a>
      </h4>
    );
  }

  if (item.subpages) {
    return item.subpages.map((subpage, subKey) => (
      <h4 key={subpage.url} className={styles.vpDrawerLink}>
        <NavLink to={subpage.url} activeClassName={styles.vpActiveLink} key={subKey}>
          {subpage.text}
        </NavLink>
      </h4>
    ));
  }

  return (
    <h4 className={styles.vpDrawerLink}>
      <NavLink to={item.url} activeClassName={styles.vpActiveLink}>
        {item.text}
      </NavLink>
    </h4>
  );
};

SidebarMenuItem.propTypes = {
  item: PropTypes.object,
};

export default SidebarMenuItem;



// WEBPACK FOOTER //
// ./src/components/Header/SidebarMenuItem.jsx